/* BRANDSETS – blok „Dobierz” (snippets/dobierz.liquid) */
(function () {
  if (window.customElements.get('dobierz-karuzela')) return;
  var ICON_PLUS = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M8 3v10M3 8h10"/></svg>';
  var ICON_OK = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M3 8.5l3.2 3L13 4.5"/></svg>';
  var ICON_X = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M4 4l8 8M12 4l-8 8"/></svg>';
  var INTERVAL = 3600;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function money(c) { return (Math.floor(c) / 100).toFixed(2).replace('.', ',') + ' zł'; }
  function num(t) { var m = String(t || '').match(/\d+(?:[.,]\d+)?/); return m ? parseFloat(m[0].replace(',', '.')) : null; }
  function range(t) { var m = String(t || '').match(/(\d+(?:[.,]\d+)?)\s*[-–]\s*(\d+(?:[.,]\d+)?)/); return m ? [parseFloat(m[1].replace(',', '.')), parseFloat(m[2].replace(',', '.'))] : null; }

  class DobierzKaruzela extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.connectedCallback.bind(this), { once: true });
        return;
      }
      if (!this.isConnected) return;
      this._ready = true;
      this.box = this.querySelector('.dz');
      this.track = this.querySelector('[data-dz-track]');
      this.bars = this.querySelector('[data-dz-bars]');
      this.keep = parseInt(this.dataset.keep || '95', 10);
      if (!this.track) return;

      var cards = Array.prototype.slice.call(this.track.children);
      for (var i = cards.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = cards[i]; cards[i] = cards[j]; cards[j] = t; }
      var max = parseInt(this.dataset.max || '6', 10);
      cards.forEach(function (c, i) { if (i >= max) c.remove(); });
      this.cards = cards.slice(0, max);
      this.cards.forEach(function (c) { this.track.appendChild(c); }, this);
      if (this.cards.length < 2) this.box.classList.add('dz-single');
      this.bars.innerHTML = this.cards.length > 1 ? this.cards.map(function () { return '<i></i>'; }).join('') : '';

      this.cur = 0; this.paused = false; this.visible = false;
      this.setShoe(this.dataset.shoe);
      this.bind();
      this.go(0, true);

      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (entries) {
          this.visible = entries[0].isIntersecting;
          this.visible ? this.schedule() : clearTimeout(this.timer);
        }.bind(this), { threshold: 0.4 });
        this.io.observe(this);
      } else { this.visible = true; this.schedule(); }
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      if (this.io) this.io.disconnect();
      if (this._onFormChange) document.removeEventListener('change', this._onFormChange);
    }
    bind() {
      var self = this;
      this.track.addEventListener('click', function (e) {
        var chip = e.target.closest('[data-dz-variant]');
        if (chip) { e.preventDefault(); if (!chip.disabled) self.addVariant(chip.closest('[data-dz-card]'), chip.dataset.dzVariant, chip); return; }
        var btn = e.target.closest('[data-dz-add]');
        if (btn) { e.preventDefault(); self.onPlus(btn.closest('[data-dz-card]')); }
      });
      this.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') self.pause(); });
      this.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') self.resume(1500); });
      this.addEventListener('focusin', function () { self.pause(); });
      this.addEventListener('focusout', function (e) { if (!self.contains(e.relatedTarget)) self.resume(3000); });
      /* dotknięcie palcem = klient przejmuje sterowanie: autoprzewijanie wyłącza się na stałe,
         żeby nic nie przewijało listy pod palcem ani zaraz po puszczeniu */
      this.addEventListener('touchstart', function () { self.stop(); }, { passive: true });
      this.track.addEventListener('wheel', function (e) { if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) self.stop(); }, { passive: true });
      var st;
      this.track.addEventListener('scroll', function () {
        clearTimeout(st);
        st = setTimeout(function () {
          var left = self.track.scrollLeft, best = 0, d = 1e9;
          self.cards.forEach(function (c, i) { var dd = Math.abs(c.offsetLeft - 14 - left); if (dd < d) { d = dd; best = i; } });
          if (best !== self.cur && (self.paused || self.stopped)) self.go(best, true, true);
        }, 120);
      }, { passive: true });

      if (this.dataset.place === 'product' && this.dataset.shoes === 'true') {
        var mapEl = this.querySelector('[data-dz-variants]');
        var map = {};
        try { map = JSON.parse(mapEl ? mapEl.textContent : '{}'); } catch (err) {}
        var read = function () {
          var input = document.querySelector('product-info [name="id"], form[action*="/cart/add"] [name="id"]');
          if (input && map[input.value]) self.setShoe(map[input.value]);
        };
        this._onFormChange = function () { setTimeout(read, 80); };
        document.addEventListener('change', this._onFormChange);
      }
    }
    /* rozmiar pasujący do butów – tylko podkreślamy, klient i tak wybiera sam */
    setShoe(t) {
      var size = num(t);
      this.querySelectorAll('[data-dz-pick]').forEach(function (pick) {
        var done = false;
        pick.querySelectorAll('[data-dz-variant]').forEach(function (chip) {
          var r = range(chip.dataset.t);
          var hit = !done && !chip.disabled && size && r && size >= r[0] && size <= r[1];
          chip.classList.toggle('is-suggested', !!hit);
          if (hit) done = true;
        });
      });
    }
    onPlus(card) {
      if (!card) return;
      var pick = card.querySelector('[data-dz-pick]');
      if (!pick) { this.addVariant(card, card.querySelector('[data-dz-add]').dataset.variantId, null); return; }
      card.classList.contains('is-picking') ? this.closePick(card, true) : this.openPick(card);
    }
    openPick(card) {
      this.cards.forEach(function (c) { if (c !== card) this.closePick(c, false); }, this);
      this.pause();
      this.picking = true;
      this.go(this.cards.indexOf(card), false);
      card.classList.add('is-picking');
      card.querySelector('[data-dz-pick]').hidden = false;
      var btn = card.querySelector('[data-dz-add]');
      btn.innerHTML = ICON_X;
      btn.setAttribute('aria-label', 'Zamknij wybór rozmiaru');
      var first = card.querySelector('.dz-chip.is-suggested') || card.querySelector('.dz-chip:not([disabled])');
      if (first) { try { first.focus({ preventScroll: true }); } catch (e) {} }
    }
    closePick(card, resume) {
      if (!card || !card.classList.contains('is-picking')) return;
      card.classList.remove('is-picking');
      var pick = card.querySelector('[data-dz-pick]');
      if (pick) pick.hidden = true;
      var btn = card.querySelector('[data-dz-add]');
      var added = btn.classList.contains('is-added');
      btn.innerHTML = added ? ICON_OK : ICON_PLUS;
      btn.setAttribute('aria-label', added ? 'Dodano do koszyka' : 'Dodaj do koszyka');
      this.picking = false;
      if (resume) this.resume(3000);
    }
    showChosen(card, chip) {
      var chosen = card.querySelector('[data-dz-chosen]');
      var out = card.querySelector('[data-dz-price]');
      if (!chip || !chosen || !out) return;
      var base = parseInt(chip.dataset.price, 10);
      out.innerHTML = '<b>' + money(base * this.keep / 100) + '</b><s>' + money(base) + '</s>';
      chosen.textContent = 'Rozm. ' + chip.dataset.t;
      chosen.hidden = false;
    }
    addVariant(card, id, chip) {
      if (!card || !id) return;
      var self = this;
      var btn = card.querySelector('[data-dz-add]');
      card.classList.add('is-loading');
      var sections = ['cart-drawer', 'cart-counter'];
      var main = document.getElementById('main-cart-items');
      var mainId = main && main.dataset ? main.dataset.id : null;
      if (mainId) sections.push(mainId);
      var inCart = this.dataset.place === 'cart';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }], sections: sections.join(','), sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status && data.status !== 200) throw new Error(data.description || data.message || 'add failed');
          card.classList.remove('is-loading');
          btn.classList.add('is-added');
          self.closePick(card, false);
          btn.innerHTML = ICON_OK;
          btn.setAttribute('aria-label', 'Dodano do koszyka');
          self.showChosen(card, chip);
          self.resume(2500);
          setTimeout(function () { DobierzKaruzela.refresh(data, mainId); }, inCart ? 650 : 0);
        })
        .catch(function (err) {
          console.error('[dobierz]', err);
          card.classList.remove('is-loading');
          var el = chip || btn;
          el.animate && el.animate([{ transform: 'translateX(-3px)' }, { transform: 'translateX(3px)' }, { transform: 'none' }], { duration: 300 });
        });
    }
    go(n, instant, noScroll) {
      if (!this.cards.length) return;
      this.cur = (n + this.cards.length) % this.cards.length;
      var cur = this.cur;
      this.cards.forEach(function (c, i) { c.classList.toggle('is-active', i === cur); });
      var bars = this.bars.children;
      for (var i = 0; i < bars.length; i++) bars[i].className = i < cur ? 'done' : '';
      if (bars[cur]) { void bars[cur].offsetWidth; bars[cur].className = (reduced || this.stopped) ? 'done' : 'run'; }
      if (!noScroll) this.track.scrollTo({ left: this.cards[cur].offsetLeft - 14, behavior: instant ? 'auto' : 'smooth' });
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (reduced || this.stopped || this.paused || this.picking || !this.visible || this.cards.length < 2) return;
      this.timer = setTimeout(this.go.bind(this, this.cur + 1), INTERVAL);
    }
    pause() { this.paused = true; this.box.classList.add('is-paused'); clearTimeout(this.timer); }
    stop() {
      if (this.stopped) return;
      this.stopped = true;
      this.pause();
      var b = this.bars && this.bars.children[this.cur];
      if (b) b.className = 'done';
    }
    resume(delay) {
      clearTimeout(this.timer);
      if (this.stopped) return;
      this.timer = setTimeout(function () {
        if (this.picking || this.stopped) return;
        this.paused = false; this.box.classList.remove('is-paused'); this.go(this.cur + 1);
      }.bind(this), delay || 1500);
    }
    static refresh(data, mainId) {
      var parser = new DOMParser();
      var s = data.sections || {};
      if (s['cart-drawer']) {
        var body = document.querySelector('#CartDrawer-Body');
        var fresh = parser.parseFromString(s['cart-drawer'], 'text/html').querySelector('#CartDrawer-Body');
        if (body && fresh) body.innerHTML = fresh.innerHTML;
      }
      if (s['cart-counter']) {
        var counter = document.querySelector('#cart-counter') || document.querySelector('#shopify-section-cart-counter');
        var fc = parser.parseFromString(s['cart-counter'], 'text/html').querySelector('#shopify-section-cart-counter');
        if (counter && fc) counter.innerHTML = fc.innerHTML;
      }
      if (mainId && s[mainId]) {
        var sel = '#shopify-section-' + mainId + ' cart-items';
        var el = document.querySelector(sel);
        var fm = parser.parseFromString(s[mainId], 'text/html').querySelector(sel);
        if (el && fm) el.innerHTML = fm.innerHTML;
      }
      if (typeof updateCartCounters === 'function') updateCartCounters();
      if (typeof updateFreeShipping === 'function') updateFreeShipping();
    }
  }
  window.customElements.define('dobierz-karuzela', DobierzKaruzela);
})();
